<h1 mat-dialog-title>
  {{ model ? 'Editar' : 'Agregar' }}
</h1>

<form [formGroup]="form" (submit)="model ? update(form.value) : create(form.value)" appPermissionControl="P095F0001">
  <div mat-dialog-content>
    <mat-grid-list [cols]="breakpoint" rowHeight="90px" (window:resize)="onResize($event)">
      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Controles</mat-label>
            <mat-select formControlName="controlId" appPermissionControl="P095K0001">
              <mat-option [value]="food.controlId" *ngFor="let food of jsonModules">{{ food.controlName }} </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>

      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Rol</mat-label>
            <mat-select formControlName="rolId" appPermissionControl="P095K0002">
              <mat-option [value]="item.id" *ngFor="let item of roles">{{ item.description }} </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>

      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Habilitado</mat-label>
            <mat-select formControlName="enable" appPermissionControl="P095K0003">
              <mat-option [value]="true">Habilitado </mat-option>
              <mat-option [value]="false">Inhabilitado </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>

      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Visible</mat-label>
            <mat-select formControlName="visible" appPermissionControl="P095K0004">
              <mat-option [value]="true">Habilitado </mat-option>
              <mat-option [value]="false">Inhabilitado </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>
    </mat-grid-list>
  </div>

  <div mat-dialog-actions>
    <ng-container *ngIf="!loading"
      ><button class="botonFm btn-cancel" type="button" mat-raised-button (click)="close()" appPermissionControl="P095B0001">Cancelar</button>
      <button class="botonFm" mat-raised-button color="accent" appPermissionControl="P095B0002">
        {{ model ? 'Actualizar' : 'Guardar' }}
      </button>
    </ng-container>
    <button *ngIf="loading" class="botonGrandeFm" mat-raised-button color="accent" type="button" appPermissionControl="P095B0003">
      Cargando
      <mat-progress-bar mode="buffer"></mat-progress-bar>
    </button>
  </div>
</form>
